const skeleton = (count, fieldWidth) => {
  const element = template => {
    let str = ''
    for (let i = 0; i < count; i++) {
      const random = Math.floor((Math.random() * 60 + 20))
      str += template
        .replace('[[RANDOM]]', random)
        .replace('[[WIDTH]]', fieldWidth)
        .replace('[[MWIDTH]]', fieldWidth)
    }
    return str
  }

  return `<div class='skeleton-container'>
            ${element(`
            <div class='skeleton-box form-label' style='width: [[RANDOM]]%; max-width: [[MWIDTH]]'></div>
            <div class='skeleton-box form-field' style='width: [[WIDTH]]'></div>
            `)}
          </div>`
}

const css = `
.skeleton-box {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #ececec;
}
.skeleton-box::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  background-image: -webkit-gradient(linear,left top,right top,color-stop(0,hsla(0,0%,100%,0)),color-stop(20%,hsla(0,0%,100%,.2)),color-stop(60%,hsla(0,0%,100%,.5)),to(hsla(0,0%,100%,0)));
  background-image: linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.2) 20%,hsla(0,0%,100%,.5) 60%,hsla(0,0%,100%,0));
  -webkit-animation: shimmer 3s infinite;
  animation: shimmer 3s infinite;
  content: '';
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

.skeleton-box.form-label {
  height: 1.25em;
  width: 50%;

  margin: 2px 0 4px;
  display: block;
}
.skeleton-box.form-field.form-field {
  height: 2.75em;
  width: 101%;

  background-image: none;
  background-color: #ececec;
  border: none;

  margin-bottom: 14.25px;
}

.loading.skeleton > * {
  visibility: hidden;
}
.loading.skeleton > .skeleton-loader {
  visibility: visible;
}

.loading .skeleton-container {
  display: block;
  opacity: 1;
  z-index: 1;
}
.loading.skeleton.bare .skeleton-container,
.loading.skeleton.list .skeleton-container {
  /*position: static;*/
}
.skeleton-container {
  /*display: none;*/
  opacity: 0;
  transition: opacity 0.5s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
}
`

const DEFAULT_COUNT = 5

const LOADING = {
  name: 'loading',
  bind(el, binding, vnode) {
    const endpoint = binding.value
    if (!endpoint) return

    let count = Object.keys(binding.modifiers)[0]
    count = !isNaN(count) && +count || DEFAULT_COUNT

    const field = el.querySelector('*:first-child:not(label)')
    const skeletonNode = document.createElement('div')
    skeletonNode.className = 'skeleton-loader'
    // skeletonNode.innerHTML = skeleton(count, fieldWidth)

    setTimeout(() => {
      const fieldWidth = field && field.getBoundingClientRect().width
        ? `${field.getBoundingClientRect().width + 2}px`
        : 'calc(100% + 2px)'
      skeletonNode.innerHTML = skeleton(count, fieldWidth)
    }, 0)

    el.setAttribute('endpoint', endpoint)
    el.style.position = 'relative'
    el.classList.add('ghost', 'skeleton')
    !field && el.classList.add('bare')
    el.appendChild(skeletonNode)
    setTimeout(() => {
      el.style.minHeight = el.querySelector('.skeleton-container').getBoundingClientRect().height + 'px'
    }, 0)
  }
}

skeletonStyles()

export default LOADING

function skeletonStyles() {
  const head = document.head || document.getElementsByTagName('head')[0]
  const style = document.createElement('style')

  head.appendChild(style)

  style.type = 'text/css'
  if (style.styleSheet) {
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }
}



// WEBPACK FOOTER //
// ./src/core/directives/loading.js